import React, {useEffect, useContext} from "react";
import BasicView from "../../components/BasicView";
import {HeadSuscribe} from "../../styles/HeadsVies";
import {SecondView} from "../../styles/HeadView";
import SuscribeModal from "./SuscribeModal";
import PageNotFound from "../others/PageNotFound";
import {ThemaryComponent, ProfileComponent, NextCourses} from "./components/DetailsComponents";
import ExperienceSection from "./components/ExperienceSection";
import FacilitadorSection from "./components/FacilitadorSection";
import FloatButton from "./components/FloatButton";
import {useParams} from "react-router-dom";
import {CoursesContext} from "../../context/CoursesContext";
import {LoadComponet} from "../../components/loaders/Loader";
import {isMobile} from "../../constants/Helpers";

export default function MasterclassDetails() {
   const {getInfoCourse, courseData, listWebFacilitators, getInfoFacilitators} = useContext(CoursesContext);
   const {id} = useParams();

   useEffect(() => {
      getInfoFacilitators();
   }, []);

   useEffect(() => {
      getInfoCourse(id);
   }, [id]);

   useEffect(() => {
      let nTitle = courseData.courseName ? courseData.courseName + " - Domecq Academy" : "Domecq Academy";
      document.title = nTitle;
      return () => {
         document.title = "Domecq Academy";
      };
   }, [id]);

   if (courseData.isLoading) return <LoadComponet isVisible={true} />;
   if (!courseData) return <PageNotFound />;
   return (
      <>
         <BasicView
            imageBack={`http://domecqapi.trebolbit.com/${isMobile ? courseData.pathImageDesktop : courseData.pathImageMobile}`}
            isSecondary={true}
         >
            <HeadSuscribe data={courseData} />
            <SecondView>
               <ThemaryComponent />
               {/* Facilitador consejo vinicola */}
               {!listWebFacilitators.isLoading && <FacilitadorSection />}
               <ProfileComponent />
               <NextCourses />
               <ExperienceSection />
               <FloatButton />
            </SecondView>
         </BasicView>
         <SuscribeModal />
      </>
   );
}

// const CoachInfoList = [{name: "Consejo mexicano vitivinícola", id: "8", img: require("../../assets/image/logo-cmv.png"), type: "cmv"}];
